module.exports = __webpack_public_path__ + "static/media/40.d55e32c2.jpg";